module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/icons/svg/icon-more.svg
// module id = 906
// module chunks = 0